<template>
  <v-row v-if="displayObject">
		<v-col>
			<component v-bind:is="objects[type].component" v-bind="objects[type].props"></component>
		</v-col>
	</v-row>
</template>

<script> 
	import client from "../store/modules/Client.js"
	import Vuex from 'vuex';

	export default{
		name: "Single",
		props: {
			'type': { type: String}, 
			'object': {type: Object}, 
			'retrieve': {type: Boolean, default: false}
		},
		components: {
			"ViewProject": () => import('../components/singles/ViewProject'),
			"ViewAppointment": () => import('../components/singles/ViewAppointment'),
			"ViewRequest": () => import('../components/singles/ViewRequest')
		},
		data() {
			return {
			}
		},
		computed: {
			...Vuex.mapState({
				displayObject: function(){
					const self = this;
					let foundObject = self.$store.state.client[self.type].find( p => p.id == self.$route.params.id )
					return foundObject;
					
				}
			}),
			objects: function() {
				return {
					projects: {
						component: "ViewProject",
						props: { project: this.displayObject }
					},
					appointments: {
						component: "ViewAppointment",
						props: { appointment: this.displayObject }
					},
					requests: {
						component: "ViewRequest",
						props: { request: this.displayObject }
					}
				}
			}
		},
		methods: {
			back: function(){
				this.$router.go(-1)
			},
			notFound: function(){

				// this.$router.push('../')
			}
		},
		created: function(){
			const self = this;
			if( !self.$store.state.client ){
				self.$store.registerModule('client', client )
				if( self.type == 'projects'){
					self.$store.dispatch( 'bindProject', self.$route.params.id );
				}
				if( self.type == 'requests'){
					self.$store.dispatch( 'fetchRequest', self.$route.params.id );
				}
				if( self.type == 'appointments'){
					self.$store.dispatch("getDoc", {
						doc: "appointments/" + self.$route.params.id
					}).then( doc => {
						let pId = doc.project;
						if( !pId ){
							return
						}
						self.$store.dispatch( 'bindProject', pId );
					})
				}
			}

		}
	}
</script>